import { Component, Inject, OnInit } from '@angular/core'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { CrudOps } from '../../../../api/constants/crud.enum'
import { Client } from '../../../../api/models/client.model'
import { ClientService } from '../../../../api/services/client.service'
import { LoaderService } from '../../../common/services/loader.service'
import { SnackbarService } from '../../../common/services/snackbar.service'

export interface ClientDialogData {
    crud: CrudOps
    client: Client
}

@Component({
    selector: 'ppw-app-clients-dialog',
    templateUrl: './clients-dialog.component.html',
    styleUrls: ['./clients-dialog.component.scss']
})
export class ClientsDialogComponent implements OnInit {
    dialogTitle!: string
    crud!: CrudOps
    newClientName?: string
    isValid!: boolean
    hasChanges!: boolean

    private readonly prefix = 'EmployeesComponent'

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ClientDialogData,
        readonly dialogRef: MatDialogRef<ClientsDialogComponent>,
        readonly dialog: MatDialog,
        readonly clientService: ClientService,
        private readonly loaderService: LoaderService,
        private readonly snackbarService: SnackbarService
    ) {}

    ngOnInit(): void {
        this.crud = this.data.crud
        this.crudHandler()
        this.checkIsValid()
        this.checkHasChanges()
    }

    crudHandler(): void {
        switch (this.data.crud) {
            case CrudOps.Create:
                this.dialogTitle = 'New Client'
                break
            case CrudOps.Update:
                this.dialogTitle = 'Edit Client'
                this.newClientName = this.data.client.name
                break
            case CrudOps.Delete:
                this.dialogTitle = 'Delete (= Archive) Client'
                this.newClientName = this.data.client.name
                break
            default:
                this.dialogTitle = ''
        }
    }

    cancelDialog(): void {
        this.dialogRef.close()
    }

    checkValidChanges(): void {
        this.checkIsValid()
        this.checkHasChanges()
    }

    checkIsValid(): void {
        this.newClientName === '' || this.newClientName === undefined || this.newClientName.length > 40
            ? (this.isValid = false)
            : (this.isValid = true)
    }

    checkHasChanges(): void {
        this.data.client.name !== this.newClientName ? (this.hasChanges = true) : (this.hasChanges = false)
    }

    saveClient(): void {
        this.loaderService.startLoading()
        if (this.newClientName) {
            this.data.client.name = this.newClientName
        }
        this.clientService
            .saveClient(this.data.client)
            .then((savedClient: Client) => {
                this.data.client = savedClient
                this.closeAndSendResponse()
            })
            .catch((err: any) => {
                this.snackbarService.handleError(this.prefix, err, true)
            })
            .finally(() => {
                this.loaderService.stopLoading()
            })
    }

    archiveClient(): void {
        this.loaderService.startLoading()
        this.clientService
            .archiveClient(this.data.client)
            .then((archivedClient: Client) => {
                this.data.client = archivedClient
                this.closeAndSendResponse()
            })
            .catch((err: any) => {
                this.snackbarService.handleError(this.prefix, err, true)
            })
            .finally(() => {
                this.loaderService.stopLoading()
            })
    }

    private closeAndSendResponse(): void {
        this.dialogRef.close({
            crud: this.crud,
            client: this.data.client
        })
    }
}
